<form [formGroup]="formGroup" *ngIf="formMetadata?.length > 0" [class.popover]="presentationStyle" [class.notPopover]="!presentationStyle">
    <div *ngFor="let metadata of formMetadata" class="formFieldsWrapper">
        <ng-container *ngIf="isSlider(metadata); else notSlider">
            <clare-slider
                [theForm]="formGroup"
                [metaData]="metadata"
                [enableRetry]="enableRetry"
                [isLoading]="isLoading"
                (getValueEmitter)="getInitialValue($event)"
            ></clare-slider>
        </ng-container>
        <ng-template #notSlider>
            <ng-container *ngIf="isButtonToggle(metadata); else notButtonToggle">
                <clare-button-toggle
                    [theForm]="formGroup"
                    [metaData]="metadata"
                    [enableRetry]="enableRetry"
                    [isLoading]="isLoading"
                    (getValueEmitter)="getInitialValue($event)"
                ></clare-button-toggle>
            </ng-container>
        </ng-template>
        <ng-template #notButtonToggle>
            <ng-container *ngIf="isSlideToggle(metadata); else notToggle">
                <clare-slidetoggle
                    [theForm]="formGroup"
                    [metaData]="metadata"
                    [enableRetry]="enableRetry"
                    [isLoading]="isLoading"
                    (getValueEmitter)="getInitialValue($event)"
                ></clare-slidetoggle>
            </ng-container>
        </ng-template>
        <ng-template #notToggle>
            <ng-container *ngIf="isSelect(metadata); else notSelect">
                <clare-select
                    [showLabel]="showSelectLabels"
                    [theForm]="formGroup"
                    [metaData]="metadata"
                    [enableRetry]="enableRetry"
                    [isLoading]="isLoading"
                    (getValueEmitter)="getInitialValue($event)"
                ></clare-select>
            </ng-container>
        </ng-template>
        <ng-template #notSelect>
            <ng-container *ngIf="isCheckbox(metadata); else notCheckbox">
                <clare-checkbox
                    [theForm]="formGroup"
                    [metaData]="metadata"
                    [enableRetry]="enableRetry"
                    [isLoading]="isLoading"
                    [isRequired]="checkboxRequired"
                    (getValueEmitter)="getInitialValue($event)"
                ></clare-checkbox>
            </ng-container>
        </ng-template>
        <ng-template #notCheckbox>
            <clare-text-input
                [theForm]="formGroup"
                [metaData]="metadata"
                [isLoading]="isLoading"
                [enableRetry]="enableRetry"
            ></clare-text-input>
        </ng-template>
    </div>
    <button
        [class.fullWidthButton]="fullWidthSaveButton"
        color="primary"
        class="new-primary-button"
        mat-raised-button
        (click)="saveForm()"
        *ngIf="showSave"
    >
        <ng-container i18n="@@SHARED.BTN.SAVE">Save</ng-container>
    </button>
</form>
